// extracted by mini-css-extract-plugin
export default {"rejectAnswerBlock":"rejectAnswer_rejectAnswerBlock__4Ab0r","iconContainer":"rejectAnswer_iconContainer__x4O+A","text":"rejectAnswer_text__vduSC"};